// Simple Backorder Modal Script
document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('.js-product-form');
  const addToCartButton = document.querySelector('.add-to-cart');
  const modal = document.getElementById('backorder-modal');
  const confirmButton = document.getElementById('backorder-confirm');
  const cancelButton = document.getElementById('backorder-cancel');
  const closeButton = document.querySelector('.backorder-modal-close');
  const overlay = document.querySelector('.backorder-modal-overlay');
  const variantPicker = document.querySelector('variant-picker');
  const backorderDiv = document.querySelector('.backorder');
  
  let isBackorderItem = false;
  let shouldShowModal = true;
  
  // Get product data for single-variant products
  let singleVariantData = null;
  if (!variantPicker) {
    // Try to get variant ID from hidden input
    const variantInput = productForm?.querySelector('[name="id"]');
    if (variantInput && variantInput.value) {
      // For single-variant products, get data from the page
      const metaTag = document.querySelector('meta[name="product-variant-data"]');
      if (metaTag) {
        try {
          singleVariantData = JSON.parse(metaTag.content);
        } catch (e) {
          console.error('Error parsing variant data:', e);
        }
      }
    }
  }

  function updateButtonText() {
    if (!addToCartButton) return;

    const defaultText = addToCartButton.dataset.addToCartText || 'Add to cart';

    if (isBackorderItem) {
      addToCartButton.textContent = 'Backorder this item';
    } else {
      addToCartButton.textContent = defaultText;
    }
  }

  function updateBackorderText() {
    if (!backorderDiv) return;
    
    let hideBackorder = true;
    
    if (isBackorderItem) {
      // Get product title for the backorder message
      const productTitleEl = document.querySelector('.product-title');
      const backorderProdEl = backorderDiv.querySelector('.backorder__product');
      
      if (backorderProdEl && productTitleEl) {
        // For single-variant products, no variant title needed
        backorderProdEl.textContent = productTitleEl.textContent;
      }
      
      hideBackorder = false;
    }

    backorderDiv.hidden = hideBackorder;
  }
  
  function checkBackorderStatus() {
    let variant = null;
    
    // Get variant from variant-picker if it exists
    if (variantPicker) {
      variant = variantPicker.variant;
    } 
    // Otherwise use single variant data
    else if (singleVariantData) {
      variant = singleVariantData;
    }
    
    // Check if variant exists and has inventory tracking
    if (!variant || variant.inventory_management !== 'shopify') {
      isBackorderItem = false;
      updateButtonText();
      updateBackorderText();
      return;
    }

    // Get the quantity being added
    const quantityInput = document.querySelector('#quantity') || document.querySelector('[name="quantity"]');
    const requestedQty = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    const availableQty = variant.inventory_quantity;

    // Check if requesting more than available OR completely out of stock
    isBackorderItem = requestedQty > availableQty || availableQty <= 0;

    updateButtonText();
    updateBackorderText();
  
    console.log('Backorder check:', {
      requestedQty,
      availableQty,
      isBackorderItem,
      isSingleVariant: !variantPicker
    });
  }

  // Check initially
  checkBackorderStatus();

  // Listen for variant changes (only for multi-variant products)
  document.addEventListener('on:variant:change', function(e) {
    setTimeout(checkBackorderStatus, 100);
  });

  // Listen for quantity changes
  const quantityInput = document.querySelector('#quantity') || document.querySelector('[name="quantity"]');
  if (quantityInput) {
    quantityInput.addEventListener('input', checkBackorderStatus);
    quantityInput.addEventListener('change', checkBackorderStatus);
  }

  // Listen for quantity button clicks
  const quantityButtons = document.querySelectorAll('[data-quantity]');
  quantityButtons.forEach(button => {
    button.addEventListener('click', () => {
      setTimeout(checkBackorderStatus, 50);
    });
  });
  
  function showModal() {
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
  
  function hideModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
    shouldShowModal = true;
  }
  
  // Complete the add to cart process
  function completeAddToCart() {
    shouldShowModal = false;
    
    if (productForm) {
      productForm.submit();
      return;
    }
    
    if (addToCartButton) {
      addToCartButton.click();
      return;
    }
    
    const formData = new FormData(productForm);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      window.location.reload();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
  }
  
  if (addToCartButton) {
    addToCartButton.addEventListener('click', function(e) {
      if (isBackorderItem && shouldShowModal) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showModal();
        return false;
      }
    }, true);
  }
  
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      if (isBackorderItem && shouldShowModal) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showModal();
        return false;
      }
    }, true);
  }
  
  if (confirmButton) {
    confirmButton.addEventListener('click', function() {
      hideModal();
      completeAddToCart();
    });
  }
  
  [cancelButton, closeButton, overlay].forEach(element => {
    if (element) {
      element.addEventListener('click', hideModal);
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'block') {
      hideModal();
    }
  });
});